window.sq = window.sq || {};
  window.sq.onCartAdded = function(){
      jQuery.ajax({
          type: "GET",
          url: '/',
          dataType: 'HTML',
          async: false,
          success: function(response) {   
            // find the element in the response and then update the document's element
                  let cartCountElements = $(response).find('#_desktop_cart');
                  console.log("cart updated");
                  if (cartCountElements && cartCountElements.length) {
                          let count = cartCountElements[0].innerHTML;
                          if(count){
                                  Array.from($(document).find('#_desktop_cart')).forEach(x => {x.innerHTML = `${count}`})
                          }
                  }
              let cartDrawerElement = $(response).find('#cart-notification');
                   console.log("drawer updated");
                    if (cartDrawerElement && cartDrawerElement.length) {
                          let count1 = cartDrawerElement[0].innerHTML;
                          if(count1){
                            console.log(count1);
                                  Array.from($(document).find('#cart-notification')).forEach(x => {x.innerHTML = count1;})
                          }
                  } 
              setTimeout(()=>{ 
                              let atc = document.querySelector('#_desktop_cart');
                          if(atc){
                            atc.click();
                      } }, 1000);
          }
      })
  }